import { createFeatureSelector, createSelector } from '@ngrx/store';
import { State, referralAccountSettingsFeatureKey } from './referral-account-settings.reducer';

export const selectReferralAccountSettingsState =
  createFeatureSelector<State>(referralAccountSettingsFeatureKey);

export const selectReferralUser = createSelector(
  selectReferralAccountSettingsState,
  (state) => state.user
);

export const selectReferralAccountSettingsLoading = createSelector(
  selectReferralAccountSettingsState,
  (state) => state.loading
);

export const selectReferralAccountSettingsError = createSelector(
  selectReferralAccountSettingsState,
  (state) => state.error
);

export const selectReferralAccountSettingsLastSaveResult = createSelector(
  selectReferralAccountSettingsState,
  (state) => state.lastSaveResult
);
